import * as tslib_1 from "tslib";
import debounce from 'lodash/debounce';
import React, { Component } from 'react';
import ListControlPanel from './ListControlPanel';

var ListHeader =
/** @class */
function (_super) {
  tslib_1.__extends(ListHeader, _super);

  function ListHeader() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      search: _this.props.search,
      prevSearchFromProps: _this.props.search
    };
    _this.triggerSearch = debounce(function (search) {
      _this.props.onSearchChange(search);
    }, 800);

    _this.handleSearchChange = function (search) {
      _this.setState({
        search: search
      });

      _this.triggerSearch(search);
    };

    return _this;
  }

  ListHeader.getDerivedStateFromProps = function (props, prevState) {
    if (prevState.prevSearchFromProps !== props.search) {
      return {
        search: props.search,
        prevSearchFromProps: props.search
      };
    }

    return null;
  };

  ListHeader.prototype.render = function () {
    var _a = this.props,
        onAddButtonClick = _a.onAddButtonClick,
        onLimitChange = _a.onLimitChange,
        // search,
    pagination = _a.pagination,
        onPageChange = _a.onPageChange,
        addButtonText = _a.addButtonText,
        withoutSearch = _a.withoutSearch,
        withoutAddButton = _a.withoutAddButton,
        withoutPerPage = _a.withoutPerPage,
        withoutPagination = _a.withoutPagination,
        isLoading = _a.isLoading;
    return React.createElement(ListControlPanel, {
      buttonComponent: this.props.buttonComponent,
      isLoading: isLoading,
      searchValue: this.state.search,
      onPerPageChange: onLimitChange,
      onAddButtonClick: onAddButtonClick,
      onSearchChange: this.handleSearchChange,
      pagination: pagination,
      onPageChange: onPageChange,
      addButtonText: addButtonText,
      withSearch: !withoutSearch,
      withAddButton: !withoutAddButton,
      withPerPage: !withoutPerPage,
      withPagination: !withoutPagination
    });
  };

  return ListHeader;
}(Component);

export default ListHeader;